import { File, ExternalLink } from "lucide-react";

type ChatbotBenefitDocumentProps = {
  documentName: string;
  documentLink: string;
};

const ChatbotBenefitDocument = ({
  documentName,
  documentLink,
}: ChatbotBenefitDocumentProps) => {
  const openDocument = () => {
    window.open(documentLink, "_blank");
  };

  return (
    /*
      2.1.1 Keyboard — A / 4.1.2 Name, Role, Value — A. This was a <div onClick> opening a
      benefit document in a new tab: not focusable, no role, so a keyboard or screen reader
      user could not open the document at all. The "opens in a new tab" note is included in
      the accessible name because the window change is otherwise unannounced.
    */
    <button
      type="button"
      onClick={openDocument}
      className="border-border/20 hover:border-border/40 w-full cursor-pointer rounded-lg border bg-card p-4 pr-6 text-left shadow-sm transition-all duration-200 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <File
            aria-hidden="true"
            className="size-5 flex-shrink-0 text-muted-foreground"
          />
          <span className="font-medium text-gray-600">{documentName}</span>
          <span className="sr-only">(opens in a new tab)</span>
        </div>
        <ExternalLink
          aria-hidden="true"
          className="size-4 flex-shrink-0 text-muted-foreground"
        />
      </div>
    </button>
  );
};

export default ChatbotBenefitDocument;
